import { NgModule } from "@angular/core";
import { OneCoreMapHereComponent } from "./components/one-core-map-here/one-core-map-here.component";
import { BrowserModule } from "@angular/platform-browser";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { OpenStreetMapService } from "./services/open-street-map.service";
import { ApiHereService } from "./services/api.here.service";
import { ToolbarMapComponent } from "./components/toolbar-map/toolbar-map.component";
import { LayoutMapComponent } from "./components/layout-map/layout-map.component";
import { SearchDirectionComponent } from "./components/search-direction/search-direction.component";
import { MatButtonModule, MatFormFieldModule } from "@angular/material";
import { DistanceService } from "./services/distance.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [
    OneCoreMapHereComponent,
    SearchDirectionComponent,
    ToolbarMapComponent,
    LayoutMapComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatFormFieldModule, MatButtonModule,
    TranslateModule
  ],
  providers: [
    ApiHereService,
    OpenStreetMapService,
    DistanceService
  ],
  exports: [
    OneCoreMapHereComponent,
    SearchDirectionComponent,
    ToolbarMapComponent,
    LayoutMapComponent
  ],
  bootstrap: [OneCoreMapHereComponent]
})
export class MapModule {
  constructor(translate: TranslateService) {
    translate.setDefaultLang('es-Mx');
    translate.use('es-Mx');
  }
}
